
import { IAccelerationTask } from '../types/IAccelerationTask';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { ISchedule } from '../types/ISchedule';
import { ISiteNameWithId } from '../types/ISiteNameWithId';
import { IUser } from '../types/IUser';
import { INamedItem } from '../types/resourceParts';
import { Request } from './Request';


export interface IGetAccelerationTasksResult extends IGetItemsResult {
  tasks: IAccelerationTask[];
  workbooks: INamedItem[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
  users: IUser[];
  projects: INamedItem[];
}

export class GetAccelerationTasksRequest extends Request<IGetItemsParams, IGetAccelerationTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getAccelerationTasks', params);
  }
}
